import { Component, OnInit, EventEmitter, Output , ViewChild, ElementRef, Input} from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { GetDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import { DomSanitizer, SafeUrl, SafeResourceUrl  } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})

export class DocumentViewerComponent implements OnInit {
   
  documentdetails= new GetDocumentDetails();
  viewer = 'google';
  organizationId: string;
  databaseId: string;
  currentUser: any;

  showDetail:boolean = false;
  CloseViewDocument:boolean = false;    
  clickEventsubscription: Subscription;

  //responseHolder: any;
  myFormGroup: FormGroup;   
  DocumentShow:boolean;
  
  visible = true;
  selectable = true;
  removable = true;    
  
  @Output() getCloseDocumentViewer = new EventEmitter<boolean>();
 
  documentType: any;
  fileSize: string="";
  documentName: string="";
  createdOn:any;    

  modulename:string;  
  documentID :number;
  documentpath: SafeResourceUrl;
  showLocalPanel: boolean = false;
  fileDetails:any=[]=[];

  constructor(    
    private dialog: MatDialog,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,
    private _dataSharingService: DataSharingService,
    public sanitizer: DomSanitizer,
    private formBuilder: FormBuilder
  ) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
  }

  ngOnInit(): void {
    if(environment.production) {      
      this.showLocalPanel=false;
    }else{     
      this.showLocalPanel=true;
    }
  
    // this.DocumentShow=false;
    // this.documentpath=null;
   
    this.clickEventsubscription = this._dataSharingService.getSelectedDocumentForChat().subscribe((result) => {
      if (result) { 
        this.documentName="";
        this.documentType="";
        this.fileSize="";
        this.createdOn="";
        this.fileDetails=result;
        this.documentpath= this.fileDetails.filePath;
        this.documentType = this.fileDetails.fileType;
        this.documentName =this.fileDetails.fileName;
        this.createdOn =this.fileDetails.createdOn;       
      }      
    });
  }

 

  //  getReadableFileSizeString(fileSizeInBytes) {
  //   var i = -1;
  //   var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  //   do {
  //       fileSizeInBytes = fileSizeInBytes / 1024;
  //       i++;
  //   } while (fileSizeInBytes > 1024);

  //   return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
  // };

  // getDocumentDetails(result) {
  //   this.documentpath=null;
  //   this.documentpath= (result.documentPath);
  //   this.documentModel.userID = this.currentUser.UID;
  //   this.documentModel.documentID = result.documentID;
  //   this.documentModel.databaseID = Number(this.databaseId);
  //   this.documentModel.organizationID = Number(this.organizationId);
  //   this.documentModel.type =1; // 1 FOR OCRE, 2 FOR CONTACT, 3 COMPANY     
    
  //    let reqModel = {
  //     fileManagerItemID:this.documentID,     
  //     userID:this.currentUser.UID,
  //     organizationID:Number(this.organizationId),
  //     databaseID:Number(this.databaseId),  
  //   }    
  //   this.fileManagerService.GetFileManagerFileDetail(reqModel).subscribe((response) => {
  //       if (response != undefined) {         
  //         this.responseHolder = response;
  //         if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //           this.documentdetails = response.data;
           
  //           this.documentId =  response.data.fileManagerItemID;
  //           this.documentType = response.data.name.split('.').pop();
  //           // if( this.documentType==undefined){
  //           //   this.documentType = result.fileType;
  //           // }
  //           this.fileSize = this.getReadableFileSizeString(response.data.fileSize);
  //           if(this.fileSize==undefined){
  //             this.fileSize =this.documentdetails.fileSize;
  //           }
  //           this.documentName =response.data.name;
  //           this.createdOn =result.createdOn;
  //           if(this.createdOn==undefined){
  //             this.createdOn =this.documentdetails.createdOn;
  //           }

  //           if(result.fileManagerInboxID==undefined){
  //           var path = response.data.azureblobPath;
  //           var path2 = path.replace(/\\/g, "/");
  //           if(response.data.azureblobPath.indexOf("https://")>=0){
  //           this.documentpath = response.data.azureblobPath;
  //           }
  //           else{
  //           this.documentpath = "https://ecmstorageaccount.blob.core.windows.net/ecmfilemanager/"+ path2;
  //           }
  //         }else{
  //           this.documentpath = result.azureblobPath;
  //         }         
                            
  //         }
  //       } else {
  //       }
  //     });
  // }

   

  opendocdetail() {
    this.showDetail = !this.showDetail
  }

  CloseDocumentViewer(message:boolean) {
    this.documentpath=null;
    this.getCloseDocumentViewer.emit(message);
    //this._dataSharingService.sendSelectedDocumentForChat(null);
  }

  
  close() {
    this.dialog.closeAll();
  } 
  

}
